'use client';

import clsx from 'clsx';
import { Breadcrumbs, type BreadcrumbItem } from '@/components/widget';

export type PageBreadcrumbsBarProps = {
  items: readonly BreadcrumbItem[];
  className?: string;
};

/** Site chrome wrapper for marketing breadcrumb trails. */
export default function PageBreadcrumbsBar({ items, className }: PageBreadcrumbsBarProps) {
  if (items.length < 2) return null;

  return (
    <div className={clsx('page-breadcrumbs-bar container-section', className)}>
      <Breadcrumbs items={items} scrollable />
    </div>
  );
}

PageBreadcrumbsBar.displayName = 'PageBreadcrumbsBar';
